// // import { configureStore } from "@reduxjs/toolkit";
// // import { combineReducers } from "redux";
// // import { persistReducer, persistStore } from "redux-persist";
// // // localStorage yerine sessionStorage import ediyoruz
// // import storageSession from "redux-persist/lib/storage/session";
// // import storage from "redux-persist/lib/storage";
// // import BasketReducer from "./slices/baskets/basker-slice";
// // import TableReducer from "./slices/tables/tableSlice";
// // import OrderReducer from "./slices/orders/order_slice";
// // import AuthReducer from "./slices/auth/auth_slice";
// // import CompanyReducer from "./slices/companies/company_slice";
// // import CategoryReducer from "./slices/categories/category_slice";
// // import ProductReducer from "./slices/products/product_slice";
// // import PrinterReducer from "./slices/printers/printer_slice";

// // const rootReducer = combineReducers({
// //   basket: BasketReducer,
// //   table: TableReducer,
// //   order: OrderReducer,
// //   auth: AuthReducer,
// //   company: CompanyReducer,
// //   category: CategoryReducer,
// //   product: ProductReducer,
// //   printer: PrinterReducer,
// // });

// // const persistConfig = {
// //   key: "root",
// //   // Burada storageSession kullanıyoruz
// //   storage: storage,
// // };

// // const persistedReducer = persistReducer(persistConfig, rootReducer);

// // export const store = configureStore({
// //   reducer: persistedReducer,
// //   middleware: (getDefaultMiddleware) => {
// //     // Sözdizimi burada biraz daha temizlendi
// //     return getDefaultMiddleware({
// //       serializableCheck: {
// //         ignoredActions: [
// //           "persist/PERSIST",
// //           "persist/REHYDRATE",
// //           "persist/REGISTER",
// //           "persist/FLUSH",
// //           "persist/PAUSE",
// //           "persist/PURGE",
// //         ],
// //       },
// //     });
// //   },
// // });

// // export const persistor = persistStore(store);

// // export type RootState = ReturnType<typeof store.getState>;
// // export type AppDispatch = typeof store.dispatch;
import BasketReducer from "./slices/baskets/basker-slice";
import TableReducer from "./slices/tables/tableSlice";
import OrderReducer from "./slices/orders/order_slice";
import AuthReducer from "./slices/auth/auth_slice";
import CompanyReducer from "./slices/companies/company_slice";
import CategoryReducer from "./slices/categories/category_slice";
import ProductReducer from "./slices/products/product_slice";
import PrinterReducer from "./slices/printers/printer_slice";
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage"; // LocalStorage
import sessionStorage from "redux-persist/lib/storage/session"; // SessionStorage

// 1. Ortak LocalStorage Yapılandırması (Kalıcı veriler için)
const persistentConfig = {
  key: "persistent-data", // LocalStorage'da bu isimle görünecek
  storage: storage,
};

// Auth ve Company'yi tek bir çatı altında birleştiriyoruz
const persistentReducer = combineReducers({
  auth: AuthReducer,
  company: CompanyReducer,
});

// 2. Root Yapılandırması (Geçici veriler için - SessionStorage)
const rootPersistConfig = {
  key: "root",
  storage: sessionStorage,
  blacklist: ["persistent"], // persistent altındaki verileri session'a dahil etme
};

const rootReducer = combineReducers({
  // Bu grup LocalStorage'da tutulacak
  persistent: persistReducer(persistentConfig, persistentReducer),

  // Bunlar rootPersistConfig sayesinde SessionStorage'da tutulacak
  basket: BasketReducer,
  table: TableReducer,
  order: OrderReducer,
  category: CategoryReducer,
  product: ProductReducer,
  printer: PrinterReducer,
});

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/REGISTER",
          "persist/FLUSH",
          "persist/PAUSE",
          "persist/PURGE",
        ],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
